import React from 'react';
import Multiselect from 'multiselect-react-dropdown';
import { multiSelectStyles } from '../constants';

const ComplaintTypeDropdowns = ({
  includedCTypes,
  setIncludedCTypes,
  excludedCTypes,
  setExcludedCTypes,
  complaintTypeOptions,
}) => {
  const includedIds = new Set(includedCTypes.map((ct) => ct.id));
  const excludedIds = new Set(excludedCTypes.map((ct) => ct.id));

  const includeOptions = complaintTypeOptions.filter((ct) => !excludedIds.has(ct.id));
  const excludeOptions = complaintTypeOptions.filter((ct) => !includedIds.has(ct.id));

  return (
    <div className='tw-flex tw-w-full tw-gap-6 tw-mt-4'>
      <div css={multiSelectStyles} className='tw-flex tw-flex-col tw-flex-1 tw-min-w-0'>
        <div className='tw-w-full tw-text-grey-900 tw-font-medium tw-text-500 tw-mb-2'>
          Include Complaint Types
        </div>
        <Multiselect
          avoidHighlightFirstOption
          options={includeOptions}
          selectedValues={includedCTypes}
          onSelect={(selectedList) => setIncludedCTypes(selectedList)}
          onRemove={(selectedList) => setIncludedCTypes(selectedList)}
          displayValue='name'
          placeholder='Search complaint types...'
        />
      </div>

      <div css={multiSelectStyles} className='tw-flex tw-flex-col tw-flex-1 tw-min-w-0'>
        <div className='tw-w-full tw-text-grey-900 tw-font-medium tw-text-500 tw-mb-2'>
          Exclude Complaint Types
        </div>
        <Multiselect
          avoidHighlightFirstOption
          options={excludeOptions}
          selectedValues={excludedCTypes}
          onSelect={(selectedList) => setExcludedCTypes(selectedList)}
          onRemove={(selectedList) => setExcludedCTypes(selectedList)}
          displayValue='name'
          placeholder='Search complaint types...'
        />
      </div>
    </div>
  );
};

export default ComplaintTypeDropdowns;
